import React from 'react';
import { BaseFilterCheckboxSelect } from '../base/BaseFilterCheckboxSelect';
import { ISelectOption } from '../../../domain/saved-filters/interface';

interface IAccountManagerFilterSelectProps {
    value: string[] | undefined;
    onChange: (value: string[]) => void;
    options: ISelectOption<string>[];
    label?: string;
    disabled?: boolean;
    isLoading?: boolean;
    height?: number;
    searchable?: boolean;
    resizable?: boolean;
}

export const AccountManagerFilterSelect: React.FC<IAccountManagerFilterSelectProps> = ({
    value = [],
    onChange,
    options,
    label,
    disabled = false,
    isLoading,
    height = 260,
    searchable = true,
    resizable = true,
}) => {
    return (
        <BaseFilterCheckboxSelect
            resizable={resizable}
            searchable={searchable}
            multiple
            showSelectAllOption={false}
            selectedCountInLabel
            showClear
            options={options}
            value={value}
            onChange={onChange}
            label={label}
            disabled={disabled}
            loading={isLoading}
            height={height}
        />
    );
};
